module.exports = __webpack_public_path__ + "img/Ptuapp5.01e5c49b.png";